export const pieColors = ["#6593CB", "#FD936E", "#FFC474", "#99E2BA", "#EE7373", "#AEC6E4"];
